module.exports = __webpack_public_path__ + "img/Group 5358.7170f6b9.png";